import {
  WithNativeHTMLProps,
} from "@kalyzee/kast-web-sdk/web-components";
import React, { useRef } from "react";
import { formatTimer, OverlayContainer, VideoPauseOverlay } from "@kalyzee/kalyzee-ui";
import { MainClockRenderer } from "../renderers/mainClock";

export interface PauseViewProps extends WithNativeHTMLProps<HTMLDivElement> {
  meetingPaused?: boolean;
  meetingPausedAt?: string;
  onResume?: () => void;
  hide?: boolean;
  className?: string;
  isExpert?: boolean;
  enabled?: boolean;
  children: React.ReactNode;
}

const PauseView = React.memo(({
  meetingPaused,
  meetingPausedAt,
  onResume, 
  hide = false,
  enabled, 
  children,
}: PauseViewProps) => {
  const defaultDateRef = useRef<Date>(new Date());
  // ---------------------------------------------------------------------- //
  // ---------------------------  RENDER ----------------------------- //
  // ---------------------------------------------------------------------- //

  if (hide || !meetingPaused) return <>{children}</>;

  const pausedAt = meetingPausedAt ? new Date(meetingPausedAt) : defaultDateRef.current;

  const timerNode = (
    <MainClockRenderer
      render={_ => formatTimer(pausedAt)}
    />
  );

  return (
    <OverlayContainer
      nativeProps={{
        onClick: () => enabled && onResume?.(),
      }}
      style={{
        cursor: enabled ? "pointer" : "default",
      }}
      overlay={
        <VideoPauseOverlay
          timerNode={timerNode}
          onResume={enabled ? () => {} : undefined} // Just to show hover animation
        />
      }
    >
      {children}
    </OverlayContainer>
  );

});

export default PauseView;
